// Module
var code = `<!DOCTYPE html> <html> <head> <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/> <style> html {
            font-size: 16px;
        }

        @supports (font: -apple-system-body) {
            html {
                font: -apple-system-body;
            }
        }

        body {
            margin: 0;
            padding: 0;
            font-family: Helvetica, Arial, sans-serif;
            line-height: 1.3;
        }

        :root {
            --title-font-size: 30px;
            --title-text-align: center;
            --title-color: inherit;
            --title-font-weight: normal;

            --text-font-size: 16px;
            --text-text-align: center;
            --text-color: inherit;
            --text-font-weight: normal;

            --next-button-color: #FFF;
            --next-button-background-color: #5381c3;
            --next-button-font-weight: bold;
            --next-button-letter-spacing: normal;
            --next-button-text-transform: none;
            --next-button-background-image: none;
        }

        .partial-html-step {
            margin: 20px;
            margin-top: 10px;
        }

        .partial-html-step a {
            color: rgba(0, 127, 249, 1);
            text-decoration: none;
        }

        .partial-html-step p {
            font-size: 1em;
            line-height: 1.3em;
            text-align: center;
            margin-top: 15px;
            margin-bottom: 15px;
            font-size: var(--text-font-size);
            text-align: var(--text-text-align);
            font-weight: var(--text-font-weight);
            color: var(--text-color);
        }

        .partial-html-step .title {
            text-align: var(--title-text-align);
            font-size: var(--title-font-size);
            font-weight: var(--title-font-weight);
            color: var(--title-color);
            margin-top: 0;
            margin-bottom: 15px;
        }

        .partial-html-step h1,
        .partial-html-step h2,
        .partial-html-step h3,
        .partial-html-step h4,
        .partial-html-step h5,
        .partial-html-step h6 {
            margin-top: 0;
            margin-bottom: 15px;
        }

        .partial-html-step h1 {
            font-size: 2em;
        }

        .partial-html-step h2 {
            font-size: 1.5em;
        }

        .partial-html-step h3 {
            font-size: 1.17em;
        }

        .partial-html-step h4 {
            font-size: 1em;
        }

        .partial-html-step h5 {
            font-size: 0.83em;
        }

        .partial-html-step h6 {
            font-size: 0.67em;
        }

        .partial-html-step button {
            padding: 15px;
            background-color: var(--next-button-background-color);
            background-image: var(--next-button-background-image);
            font-size: 1em;
            color: var(--next-button-color);
            font-weight: var(--next-button-font-weight);
            letter-spacing: var(--next-button-letter-spacing);
            text-transform: var(--next-button-text-transform);
            border: solid 1px var(--next-button-background-color);
            border-radius: 5px;
            cursor: pointer;
            box-sizing: border-box;
            text-align: center;
            width: 100%;
            margin-top: 20px;
            display: block;
        }

        .partial-html-step button:disabled,
        .partial-html-step button[disabled] {
            background: #FFF !important;
            color: #999 !important;
            border-color: #ccc !important;
            cursor: not-allowed;
        }

        .partial-html-step .form-item {
            margin-bottom: 24px;
        }

        .partial-html-step .form-item label {
            margin-bottom: 8px;
            margin-top: 8px;
            font-weight: normal;
            display: block;
        }

        .partial-html-step input[type="text"],
        .partial-html-step input[type="date"],
        .partial-html-step input[type="datetime-local"],
        .partial-html-step input[type="number"],
        .partial-html-step input[type="tel"],
        .partial-html-step input[type="time"],
        .partial-html-step input[type="email"] {
            border: 1px solid #C6CAD5;
            border-radius: 6px;
            padding: 12px 16px;
            line-height: 1.2em;
            width: 100%;
            box-sizing: border-box;
            font-size: 1em;
            appearance: none;
            outline-offset: -1px;
            background: none;
            text-align: left;
            display: block;
            font-family: inherit;
        }

        .partial-html-step input[type="text"]:placeholder,
        .partial-html-step input[type="date"]:placeholder,
        .partial-html-step input[type="datetime-local"]:placeholder,
        .partial-html-step input[type="number"]:placeholder,
        .partial-html-step input[type="tel"]:placeholder,
        .partial-html-step input[type="time"]:placeholder,
        .partial-html-step input[type="email"]:placeholder {
            color: #8E90A6;
            /* Firefox */
            opacity: 1;
        }

        .partial-html-step select {
            border: 1px solid #C6CAD5;
            width: 100%;
            box-sizing: border-box;
            font-size: 1em;
            line-height: 1.2em;
            outline-offset: -1px;
            border-radius: 6px;
            padding: 12px 16px;
        }

        .partial-html-step textarea {
            border: 1px solid #C6CAD5;
            border-radius: 6px;
            padding: 12px 16px;
            line-height: 1.2em;
            width: 100%;
            box-sizing: border-box;
            font-size: 1em;
            appearance: none;
            outline-offset: -1px;
            background: none;
            text-align: left;
            display: block;
            font-family: inherit;
            min-height: 150px;
        }

        .partial-html-step .spinner {
            border: 10px solid #f3f3f3;
            border-top: 10px solid #2c62ce;
            border-radius: 50%;
            width: 60px;
            height: 60px;
            animation: spin 1s linear infinite;
            margin: 2em auto;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }

            100% {
                transform: rotate(360deg);
            }
        } </style> { cssVariableOverrides } ${"<" + "script"} src="https://cdn.careevolution.com/mydatahelps-js/5.3.1/MyDataHelps.min.js" integrity="sha384-3KH3uytMAB2iGeYTlOBAHILAS5bnk90mWV1EdO8IEHum62kdo32VsdeeuqUQQEP8" crossorigin="anonymous">${"<" + "/script"}> </head> <body> <div class="partial-html-step"> { html } </div> </body> </html>`;
// Exports
export default code;